module.exports = __webpack_public_path__ + "static/source-sans-pro-latin-400italic-981d17e7c68609dcb88dce2c807a72e8.woff2";